import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/auth-context'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, profile, loading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!loading && !user && location.pathname !== '/auth/login') {
      navigate('/auth/login', { replace: true })
    }
  }, [user, loading, navigate, location.pathname])

  useEffect(() => {
    if (!loading && profile) {
      // Admin users should be on /admin routes
      if (profile.role === 'admin' && !location.pathname.startsWith('/admin')) {
        navigate('/admin/dashboard', { replace: true })
      }
      // Non-admin users should NOT be on /admin routes
      if (profile.role !== 'admin' && location.pathname.startsWith('/admin')) {
        navigate('/app/dashboard', { replace: true })
      }
    }
  }, [profile, loading, navigate, location.pathname])

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
      </div>
    )
  }

  if (!user && location.pathname !== '/auth/login') {
    return null
  }

  return <>{children}</>
}

export default ProtectedRoute 